import { render } from "./BlogFont.vue?vue&type=template&id=b38d8c88&scoped=true&ts=true"
import script from "./BlogFont.vue?vue&type=script&lang=ts"
export * from "./BlogFont.vue?vue&type=script&lang=ts"

import "./BlogFont.vue?vue&type=style&index=0&id=b38d8c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38d8c88"]])

export default __exports__